'use client';

import { useState, useEffect } from 'react';
import posthog from 'posthog-js';
import PromptAnswerWithEmail from "./prompt-email-answer";
import { Prompt } from "@/types/assessment.types";
import { metaPixelEvents, generateEventId } from '@/lib/metaPixel';

type Props = {
  prompt: Prompt;
  assessmentType: string;
  children: React.ReactNode;
};

export default function SinglePageAssessmentWrapper({ prompt, assessmentType, children }: Props) {
  const [showResults, setShowResults] = useState(false);

  // Track ViewContent event on component mount
  useEffect(() => {
    // Track assessment started - PostHog (for Signup Pageview metric)
    posthog.capture('minitools_assessment_started', {
      minitools_assessment_type: assessmentType,
      minitools_assessment_url: typeof window !== 'undefined' ? window.location.href : '',
      minitools_assessment_title: prompt.title,
    });

    // Track ViewContent event - Meta Pixel (for audience building)
    const eventId = generateEventId();
    metaPixelEvents.trackViewContent(assessmentType, prompt.title, eventId);
  }, [assessmentType, prompt.title]);

  // Render the PromptAnswerWithEmail component which handles its own state
  // We just need to hide the explanation when results are shown
  return (
    <>
      {!showResults && (
        <section className="py-16 px-6">
          <div className="max-w-6xl w-full mx-auto flex flex-col gap-8 sm:px-10">
            <div className="max-w-3xl md-container">
              {children}
            </div>
          </div>
        </section>
      )}
      <div className={showResults ? "" : "py-16 px-6"}>
        <div className={showResults ? "" : "max-w-6xl w-full mx-auto sm:px-10"}>
          <PromptAnswerWithEmail 
            prompt={prompt} 
            assessmentType={assessmentType}
            onResultsShown={setShowResults}
          />
        </div>
      </div>
    </>
  );
}